/**
 * Created by ssh on 2018/12/19
 * description: 工具类api
 **/
// import {getShareInfo, addShareInfo} from "../views/class30College/service/api.js";

const APP_COOKIE_PATHS = [
    '/',
    '/databoard',
    '/databorad',
    '/schooldataboard',
    '/schooldataborad',
    '/cloudschooldataboard',
    '/cloudschooldataborad',
    '/areaschooldataboard',
    '/regiondataboard',
    '/regiondataborad',
    '/njschooldataboard',
    '/dischooldataboard',
    '/puerschooldataboard',
    '/syareadataboard',
    '/xgareadataboard',
    '/qxareadataboard',
    '/sydataboard',
    '/qxdataboard',
    '/qingxudataboard',
    '/regionpanoramaboard',
    '/schoolpanoramaboard',
    '/gxdataboard',
    '/hsdataboard',
    '/nanjingdataboard'
];

function normalizeCookiePaths(paths) {
    return Array.from(new Set((paths || APP_COOKIE_PATHS).filter(Boolean)));
}

export default {
    /*
     *获取cookie
     */
    getCookie: function (name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        if (name === 'token') {
            reg = new RegExp("(^| )mk-sso-ticket=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return unescape(arr[2]);
        }
        return null;
    },
    /*
     *获取参数
     */
    getQueryString: function (name,url = location.href) {
        let _ = {};
        name += ''
        url += ''
        url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            _[key] = value;
            return url
        });
        return _[name]
    },
    /**
     * 计算两数之积
     * @param a
     * @param b
     */
    mulCompute(a, b) {
        var c = 0,
            d = a.toString(),
            e = b.toString();
        try {
            c += d.split(".")[1].length;
        } catch (f) {
        }
        try {
            c += e.split(".")[1].length;
        } catch (f) {
        }
        return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
    },
    /*
     *文件大小转换
     */
    bytesToSize: function (bytes) {
        let k = 1024, // or 1024
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        for (let j = 0; j < sizes.length; j++) {
            if (String(bytes).indexOf(sizes[j]) >= 0) return bytes;
        }
        if (bytes === 0) return '0 B';

        let i = Math.floor(Math.log(bytes) / Math.log(k));
        return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    /*
     *阿拉伯数字转中文数字
     */
    intToChinese: function (str) {
        str = str + '';
        var len = str.length - 1;
        var idxs = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
        var num = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
        return str.replace(/([1-9]|0+)/g, function ($, $1, idx, full) {
            var pos = 0;
            if ($1[0] != '0') {
                pos = len - idx;
                if (idx == 0 && $1[0] == 1 && idxs[len - idx] == '十') {
                    return idxs[len - idx];
                }
                return num[$1[0]] + idxs[len - idx];
            } else {
                var left = len - idx;
                var right = len - idx + $1.length;
                if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
                    pos = left - left % 4;
                }
                if (pos) {
                    return idxs[pos] + num[$1[0]];
                } else if (idx + $1.length >= len) {
                    return '';
                } else {
                    return num[$1[0]]
                }
            }
        });
    },
    /*
     *设置cookie
     */
    setCookie: function (name, value) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        this.clearCookie(name);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
    },
    /*
     *按路径清除cookie，避免同名cookie残留在子路径下
     */
    clearCookie: function (name, paths) {
        normalizeCookiePaths(paths).forEach(path => {
            document.cookie = name + "=;expires=" + new Date(0).toUTCString() + ";path=" + path;
        });
    },
    /*
     *批量按路径清除cookie
     */
    clearCookieByPaths: function (names, paths) {
        (Array.isArray(names) ? names : [names]).forEach(name => {
            this.clearCookie(name, paths);
        });
    },
    /*
     *清除cookie
     */
    clearAllCookie: function () {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (var i = keys.length; i--;)
                this.clearCookie(keys[i]);
        }
    },
    /*
     *根据传入的时间字符串转换为年月日时分秒
     */
    formatDateTime: function (inputTime) {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    /*
     *根据当前时间转换为年月日时分秒
     */
    getNowFormatDate: function () {
        var date = new Date();
        var seperator1 = "-";
        var seperator2 = ":";
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
            " " + date.getHours() + seperator2 + date.getMinutes() +
            seperator2 + date.getSeconds();
        return currentdate;
    },

    /*
     *根据传入时间转换为时分
     */
    getEndTimeFormatDate: function (inputTime, timeSlot) {
        var nowDate = new Date();
        var month = nowDate.getMonth() + 1;
        var strDate = nowDate.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        inputTime = nowDate.getFullYear() + '-' + month + "-" + strDate +
            " " + inputTime + ":00";

        var date;

        //解决ie下时间为NaN的问题
        if (this.checkBrowserIsIE()) {
            date = new Date(inputTime.replace(/\-/g, "\/"));
        } else {
            date = new Date(inputTime);
        }

        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes() + timeSlot;
        minute = minute < 10 ? ('0' + minute) : minute;

        return h + ':' + minute;
    },

    /**
     * 时间秒数格式化
     * @param s 时间戳（单位：秒）
     * @returns {*} 格式化后的时分秒
     */
    convertSecondToTime: function (s) {
        var t = '';
        if (s > -1) {
            // var hour = Math.floor(s / 3600);
            var min = Math.floor(s / 60);
            var sec = s % 60;

            // if (hour > 0) {
            //   if (hour < 10) {
            //     t = '0' + hour + "h";
            //   } else {
            //     t = hour + "h";
            //   }
            // }
            if (min < 10) {
                t += "0";
            }
            t += min + "'";
            if (sec < 10) {
                t += "0";
            }
            t += sec + "''";
        }
        return t;
    },
    /**
     * 时间秒数转小时数 精确到小数点一位
     * @param s 时间戳（单位：秒）
     * @returns {*} 格式化后的时
     */
    convertSecondToHour: function (s) {
        var hour = 0;
        if (s > -1) {
            hour = Math.round(s / 3600 * 100) / 100;
        }
        return hour;
    },

    /**
     *获取文件后缀名
     * @param filename
     * @returns {string}
     */
    get_suffix: function (filename) {
        let pos = filename.lastIndexOf('.');
        let suffix = '';
        if (pos !== -1) {
            suffix = filename.substring(pos)
        }
        return suffix;
    },
    /**
     *打开新的窗体
     */
    openNewPage: function (vm, name, argu, query) {
        let pageOpenedList = vm.$store.state.app.pageOpenedList;
        let openedPageLen = pageOpenedList.length;
        let i = 0;
        let tagHasOpened = false;
        while (i < openedPageLen) {
            if (name === pageOpenedList[i].name) { // 页面已经打开
                vm.$store.commit('pageOpenedList', {
                    index: i,
                    argu: argu,
                    query: query
                });
                tagHasOpened = true;
                break;
            }
            i++;
        }
        if (!tagHasOpened) {
            let tag = vm.$store.state.app.tagsList.filter((item) => {
                return name === item.name;
                // if (item.children) {
                //   return name === item.children[0].name;
                // } else {
                //   return name === item.name;
                // }
            });
            tag = tag[0];
            if (tag) {
                // tag = tag.children ? tag.children[0] : tag;
                if (argu) {
                    tag.argu = argu;
                }
                if (query) {
                    tag.query = query;
                }
                vm.$store.commit('increateTag', tag);
            }
        }
        vm.$store.commit('setCurrentPageName', name);
    },
    // 对Date的扩展，将 Date 转化为指定格式的String
    // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
    // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
    DateFormat: function (date, format) { //author: meizz
        if (date === null || date === "") {
            return date;
        }
        if (typeof date === String) {
            return date;
        }
        var o = {
            "M+": date.getMonth() + 1, //month
            "d+": date.getDate(),    //day
            "h+": date.getHours(),   //hour
            "m+": date.getMinutes(), //minute
            "s+": date.getSeconds(), //second
            "q+": Math.floor((date.getMonth() + 3) / 3),  //quarter
            "S": date.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) if (new RegExp("(" + k + ")").test(format))
            format = format.replace(RegExp.$1,
                RegExp.$1.length == 1 ? o[k] :
                    ("00" + o[k]).substr(("" + o[k]).length));
        return format;
    },
    //获得本月的开始日期
    getMonthStartDate() {
        let _this = this;
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年
        var nowMonth = now.getMonth(); //当前月

        var monthStartDate = new Date(nowYear, nowMonth, 1);
        return _this.formatDate(monthStartDate);
    },

    //获得本月的结束日期
    getMonthEndDate() {
        let _this = this;
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年
        var nowMonth = now.getMonth(); //当前月

        var monthEndDate = new Date(nowYear, nowMonth, _this.getMonthDays(nowMonth));
        return _this.formatDate(monthEndDate);
    },
    //获得本年的开始日期
    getYearStartDate() {
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年
        return nowYear + "-01" + "-01";
    },

    //获得本年的结束日期
    getYearEndDate() {
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年
        return nowYear + "-12" + "-31";
    },
    //获得某月的天数
    getMonthDays(myMonth) {
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年

        var monthStartDate = new Date(nowYear, myMonth, 1);
        var monthEndDate = new Date(nowYear, myMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
        return days;
    },
    //获得本周的开始日期
    getWeekStartDate() {
        let _this = this;
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年
        var nowMonth = now.getMonth(); //当前月
        var nowDay = now.getDate(); //当前日
        var nowDayOfWeek = now.getDay(); //今天本周的第几天

        var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
        return _this.formatDate(weekStartDate);
    },
    //获得本周的结束日期
    getWeekEndDate() {
        let _this = this;
        var now = new Date(); //当前日期
        var nowYear = now.getFullYear(); //当前年
        var nowMonth = now.getMonth(); //当前月
        var nowDay = now.getDate(); //当前日
        var nowDayOfWeek = now.getDay(); //今天本周的第几天

        var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
        return _this.formatDate(weekEndDate);
    },
    //格式化日期：yyyy-MM-dd
    formatDate(date) {
        var myyear = date.getFullYear();
        var mymonth = date.getMonth() + 1;
        var myweekday = date.getDate();

        if (mymonth < 10) {
            mymonth = "0" + mymonth;
        }
        if (myweekday < 10) {
            myweekday = "0" + myweekday;
        }
        return (myyear + "-" + mymonth + "-" + myweekday);
    },
    matchingUrl(url) {
        return url.match(/http[s]?:\/\/(.*?)([:\/]|$)/);
    },
    /**
     * 判断当前浏览器是否是ie浏览器
     */
    checkBrowserIsIE() {
        // 取得浏览器的userAgent字符串
        var userAgent = navigator.userAgent;
        // 判断是否IE<11浏览器
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
        // 判断是否IE的Edge浏览器
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE;
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;

        if (isIE || isEdge || isIE11) {
            return true;
        }

        return false;
    },
    /**
     * 获取浏览器版本以及版本号
     */
    getBrowserVersion() {
        // 取得浏览器的userAgent字符串
        var userAgent = navigator.userAgent;
        // 判断是否IE<11浏览器
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
        // 判断是否IE的Edge浏览器
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE;
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return 7;
            } else if (fIEVersion == 8) {
                return 8;
            } else if (fIEVersion == 9) {
                return 9;
            } else if (fIEVersion == 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }
        } else if (isEdge) {
            return 'edge';//edge
        } else if (isIE11) {
            return 11; //IE11
        } else {
            return -1;//不是ie浏览器
        }
    },
    /**
     * 获取chrome浏览器版本
     */
    getChromeVersion() {
        var arr = navigator.userAgent.split(' ');
        var chromeVersion = '';
        for (var i = 0; i < arr.length; i++) {
            if (/chrome/i.test(arr[i]))
                chromeVersion = arr[i]
        }
        if (chromeVersion) {
            return Number(chromeVersion.split('/')[1].split('.')[0]);
        } else {
            return false;
        }
    },

    /**
     * 检测是否是低版本浏览器
     */
    checkBrowserVersion() {
        let _this = this;
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1

        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion < 9) {
                return 1;
            } else {
                return -1;
            }
        } else if (isEdge) {
            return -1;
        }
        else if (isIE11) {
            return -1;
        } else if (isChrome) {
            var version = _this.getChromeVersion();
            if (version < 52) {
                return 1;
            } else {
                return -1;
            }
        } else {
            return -1;
        }
    },
    /**
     * 深度复制
     */
    deepCopy(obj) {
        if (typeof obj != 'object') {
            return obj;
        }
        var newobj = {};
        for (var attr in obj) {
            newobj[attr] = this.deepCopy(obj[attr]);
        }
        return newobj;
    },
    /**
     * 获取域名部分
     * @param str
     */
    domainURI(str) {
        let urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
        return urlReg.exec(str);
    },
    /**
     * 数字转化
     */
    convertNumber(val) {
        let endVal = 0;
        let unit = '';
        if (val < 1000) {
            endVal = val;
        } else if (val >= 1000 && val < 1000000) {
            endVal = parseInt(val / 1000);
            unit = 'K+';
        } else if (val >= 1000000 && val < 10000000000) {
            endVal = parseInt(val / 1000000);
            unit = 'M+';
        } else {
            endVal = parseInt(val / 1000000000);
            unit = 'B+';
        }
        return {
            val: endVal,
            unit: unit
        };
    },
    /**
     * 将浮点数四舍五入，取小数点后2位
     */
    toDecimal(val) {
        var f = parseFloat(val);
        if (isNaN(f)) {
            return;
        }
        f = Math.round(val * 100) / 100;
        return f;
    },

    /**
     * 是否移动端
     */
    isMobile() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * 浏览器信息
     */
    versions() {
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
        };
    },
    /**
     * 数组去重
     */
    removalArray(array) {
        return Array.from(array);
    },
    /**
     * 数据排序
     */
    reduseRepeatSort(arr) {
        var arr = [];  //定义一个临时数组
        for (var i = 0; i < arr.length; i++) {
            if (arr.indexOf(arr[i]) == -1) {
                arr.push(arr[i]);
            }
        }
        var sequence = function (a, b) {
            return a - b;
        };
        return arr.sort(sequence);
    },
    isEmpty(str) {
        if (typeof str == "undefined" || str == null || str == "") {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 根据分享Id获取分享信息
     * @param shareId 分享Id
     */
    async getShareInfo(shareId) {
        let infoObj = {};
        infoObj.isDiscount = 0;	//是否折扣 0:否 1:是
        infoObj.discountValue = 0.95; //折扣值

        let params = {
            shareId: shareId
        }
        await getShareInfo(params)
            .then(function (result) {
                if (result && parseInt(result.code) === 1) {
                    if (result.data.shareType == 1) {
                        infoObj.isDiscount = 1;
                    }
                }
            })
            .catch(function (error) {
            });
        return infoObj;
    },
    /**
     * 分享公共方法
     */
    async shareCommon(type, userId, vm) {
        let params = {
            url: this.delParam("code"),
            userId: userId
        }
        await addShareInfo(params)
            .then(function (result) {
                if (result && parseInt(result.code) === 1) {
                    //isAgent 0:不是代理 1:是代理
                    let url = "";
                    if (result.data.isAgent == 0 || result.data.isAgent == 2) {
                        url = 'shareMain';
                    } else if (result.data.isAgent == 1) {
                        url = 'agentShare';
                    }
                    vm.$router.push({
                        name: url,
                        query: {
                            shareId: result.data.shareId
                        }
                    });
                }
            })
            .catch(function (error) {
            });
    },
    /**
     * 是否在APP中
     */
    isApp() {
        return navigator.userAgent.indexOf('shishuobaAndroid') > -1;
    },
    /**
     * 删除参数
     */
    delParam(name) {
        let loca = window.location;
        let baseUrl = loca.origin + loca.pathname + "?";
        let query = loca.search.substr(1);
        if (query.indexOf(name) > -1) {
            let obj = {}
            let arr = query.split("&");
            for (let i = 0; i < arr.length; i++) {
                arr[i] = arr[i].split("=");
                obj[arr[i][0]] = arr[i][1];
            }
            ;
            delete obj[name];
            let url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
            return url;
        } else {
            return window.location.href;
        }
    },
    /**
     * 获取当前今天的日期
     */
    getTodayStr() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
        let day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
        let nowdatestr = year + "-" + month + "-" + day;
        return nowdatestr;
    },
    /**
     * 获取当前今天往前的N的日期
     */
    getNDayStr(n) {
        let toDay = new Date();
        let date = new Date(toDay - n * 24 * 3600 * 1000);
        let year = date.getFullYear();
        let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
        let day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
        let nowdatestr = year + "-" + month + "-" + day;
        return nowdatestr;
    },
    /**
     * 获取近7天日期
     */
    getSevenDayStr() {
        let date = new Date();
        let oneweekdate = new Date(date - 6 * 24 * 3600 * 1000);
        let year = oneweekdate.getFullYear();
        let month = oneweekdate.getMonth() + 1 >= 10 ? oneweekdate.getMonth() + 1 : '0' + (oneweekdate.getMonth() + 1);
        let day = oneweekdate.getDate() >= 10 ? oneweekdate.getDate() : '0' + oneweekdate.getDate();
        let nowdatestr = year + "-" + month + "-" + day;
        return nowdatestr;
    },
    /**
     * 获取距离今天n天的近7天日期
     */
    getYestodaySevenDayStr(n) {
        let toDay = new Date();
        let date = new Date(toDay - n * 24 * 3600 * 1000);
        let oneweekdate = new Date(date - 6 * 24 * 3600 * 1000);
        let year = oneweekdate.getFullYear();
        let month = oneweekdate.getMonth() + 1 >= 10 ? oneweekdate.getMonth() + 1 : '0' + (oneweekdate.getMonth() + 1);
        let day = oneweekdate.getDate() >= 10 ? oneweekdate.getDate() : '0' + oneweekdate.getDate();
        let nowdatestr = year + "-" + month + "-" + day;
        return nowdatestr;
    },
    /**
     * 获取当前日期前N个月的日期
     */
    getPreMonthDay(date, monthNum) {
        let dateArr = date.split('-');
        let year = dateArr[0]; //获取当前日期的年份
        let month = dateArr[1]; //获取当前日期的月份
        let day = dateArr[2]; //获取当前日期的日
        let days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中月的天数
        let year2 = year;
        let month2 = parseInt(month) - monthNum;
        if (month2 <= 0) {
            year2 = parseInt(year2) - parseInt(parseInt(month2 / 12) == 0 ? 1 : parseInt(month2) / 12);
            month2 = 12 - (Math.abs(month2) % 12);
        }
        let day2 = day;
        let days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        if (month2 < 10) {
            month2 = '0' + month2;
        }
        let t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
    },
    inputUp(ele) {
        //安卓机型，自动上滑露出输入框
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        alert('inputUp');
        if (isAndroid) {
            alert('isAndroid');
            $(ele).on('click', function () {
                var target = this;
                setTimeout(function () {
                    target.scrollIntoViewIfNeeded();
                }, 100);
            });
            $(ele).on('focus', function () {
                alert('111');
                //自动反弹 输入法高度自适应
                var winHeight = $(window).height(); //获取当前页面高度
                alert('winHeight=' + winHeight);
                $(window).resize(function () {
                    var thisHeight = $(this).height();
                    alert('thisHeight=' + thisHeight);
                    if (winHeight - thisHeight > 50) {
                        //当软键盘弹出，在这里面操作
                        $('body').css('height', winHeight + 'px');
                    } else {
                        //当软键盘收起，在此处操作
                        $('body').css('height', '100%');
                    }
                });
            });
        }
    },
    /**
     * 获取学年第n周的开始时间和结束时间
     * @param {string} start 学年开始日期，格式为 'yyyy-mm-dd'
     * @param {string} end 学年结束日期，格式为 'yyyy-mm-dd'
     * @param {number} n 第几周，1表示第一周，2表示第二周，以此类推
     * @return {object} 包含开始时间和结束时间的对象，格式为 {start: 'yyyy-mm-dd', end: 'yyyy-mm-dd'}
     */
    getWeekStartAndEnd(start, end, n) {
      // 将日期字符串转为 Date 对象
      const startDate = new Date(start);
      const endDate = new Date(end);

      // 计算学年开始是星期几
      const startDay = startDate.getDay() === 0 ? 7 : startDate.getDay();

      // 计算当前学年的总周数（至少一周）
      const totalWeeks = Math.ceil((endDate - startDate) / (7 * 24 * 3600 * 1000)) || 1;

      // 计算第n周的开始时间和结束时间
      const weekStartDate = new Date(startDate.getTime() + (n - 1) * 7 * 24 * 3600 * 1000 - (startDay - 1) * 24 * 3600 * 1000);
      const weekEndDate = new Date(weekStartDate.getTime() + 6 * 24 * 3600 * 1000);

      // 格式化日期字符串
      const format = dateString => dateString.toISOString().slice(0, 10);

      return { start: format(weekStartDate), end: format(weekEndDate) };
    },
    //通过开始时间结束时间返回每个日期的时间
    getDayArray(startDate, endDate) {
      const arr = [];
      const endTime = new Date(endDate)
      const currentDate = new Date(startDate);
      // 格式化日期字符串
      const format = dateString => dateString.toISOString().slice(0, 10);
    
      while (currentDate <= endTime) {
        arr.push(format(currentDate))
        currentDate.setDate(currentDate.getDate() + 1);
      }
    
      return arr;
    }

}
